import { useIntl } from 'react-intl';
import TagSystem from '_common/components/TagSystem/TagSystem';

import { Paragraph } from '@ets/design-system';

type SettingTagsProps = {
  groupId?: ObjectId;
  testId: string;
};

const SettingTags = ({ groupId, testId }: SettingTagsProps) => {
  const intl = useIntl();

  return (
    <div className="flex items-start py-8">
      <Paragraph className="text-neutral-70 min-w-xl pl-16" size="m">
        {intl.formatMessage({ id: 'settings.general.tags' })}
      </Paragraph>
      {groupId && (
        <div className="w-160 text-sm text-neutral-50">
          <TagSystem
            objectId={groupId}
            placeholder={intl.formatMessage({ id: 'SELECT_TAG' })}
            testId={testId}
            menuPlacement="top"
          />
        </div>
      )}
    </div>
  );
};

export default SettingTags;
